import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';

const GoHome: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('GoHome');

    return (
        <div className={styles.GoHome + ' GtmModuleData-section'} data-section-id="go-home">
            <div className="lp-layout go-home-container">
                <div className="go-home-left">
                    <div className="title">{t('title')}</div>
                    <div className="content">{t('content')}</div>
                    {/* <div className="footer-desc">{t('footer_desc')}</div> */}
                </div>
                <div className="go-home-right">
                    <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1764746212092-plrnvm-compressed-%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88%202025-12-01%206.37.03%201.jpg" />
                </div>
                <div className="h5-title">{t('title')}</div>
            </div>
        </div>
    );
};

export default GoHome;
